import React from "react";
import { AppBar, Box, Button, Container, Toolbar, Typography } from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import SettingsIcon from '@mui/icons-material/Settings';

const Header: React.FC = () => {
  return (
    <AppBar position="sticky" elevation={0}>
    <Container maxWidth="xl">
      <Toolbar sx={{ px: { xs: 0 }, height: 70 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}>
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 1.5,
            '& svg': { fontSize: 32, color: 'primary.main' }
          }}>
            <CloudUploadIcon />
            <Box>
              <Typography 
                variant="h6" 
                component="div" 
                sx={{ 
                  fontWeight: 600,
                  color: 'text.primary',
                  lineHeight: 1.2
                }}
              >
                Dinero Economic
              </Typography>
              <Typography 
                variant="body2" 
                sx={{ 
                  color: 'text.secondary',
                  lineHeight: 1.2
                }}
              >
                Import Tool
              </Typography>
            </Box>
          </Box>

          <Box sx={{ flex: 1 }} />

          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              startIcon={<HelpOutlineIcon />}
              sx={{ color: 'text.secondary' }}
            >
              Help
            </Button>
            {/* <Button
              startIcon={<SettingsIcon />}
              sx={{ color: 'text.secondary' }}
            >
              Settings
            </Button> */}
          </Box>
        </Box>
      </Toolbar>
    </Container>
  </AppBar>
  );
};

export default Header;
